var map = {
	"./comment/User.svg": 1233,
	"./comment/close_button.png": 801,
	"./debate-card/end/end.svg": 3520,
	"./debate-card/ongoing/ongoing.svg": 6588,
	"./debate/Like_Button.svg": 2296,
	"./debate/VS.svg": 5337,
	"./debate/reply_Button.svg": 5047,
	"./debate_grand/User.svg": 6032,
	"./debate_grand/loader.gif": 6115,
	"./debate_grand/辯論大廳-已結束.png": 9054,
	"./debate_grand/辯論大廳-待評分.png": 7272,
	"./debate_grand/辯論大廳-等待加入.png": 4896,
	"./debate_grand/辯論大廳-進行中.png": 3616,
	"./header/header_message.svg": 3043,
	"./header/header_user.svg": 3375,
	"./header/logo.png": 4681,
	"./join/Check_circle.svg": 9602,
	"./join/VS.svg": 7956,
	"./join/loader.gif": 9335,
	"./landing/CHECK.svg": 6258,
	"./landing/Header.svg": 7781,
	"./landing/Header_login.svg": 3679,
	"./landing/Hero Actions.svg": 2755,
	"./landing/REASON.svg": 7054,
	"./landing/Reason text.svg": 2767,
	"./landing/TEST ACCOUNT.svg": 4863,
	"./landing/登入即表示您同意我們的 使用條款 和 隱私政策.svg": 4509,
	"./logo.png": 3153,
	"./new_design/163_1920.svg": 8367,
	"./new_design/163_1924.svg": 707,
	"./new_design/163_1932.svg": 6590,
	"./new_design/4_2882.svg": 4159,
	"./new_design/4_470.svg": 7084,
	"./new_design/4_606.svg": 77,
	"./new_design/4_611.svg": 6961,
	"./new_design/landing/Header_login.svg": 8921,
	"./new_design/landing/Landing_Sunrise.svg": 3621,
	"./new_design/landing/Landing_connect.svg": 5054,
	"./new_design/landing/Landing_riseup.svg": 5172,
	"./new_design/landing/landing_checkbox.svg": 3303,
	"./new_design/landing/landing_guest_1.svg": 7264,
	"./new_design/landing/landing_guest_2.svg": 8275,
	"./new_design/landing/landing_guest_3.svg": 4546,
	"./new_design/landing/landing_guest_4.svg": 3069,
	"./new_design/logo.svg": 9801,
	"./new_design/standard_eye.svg": 6417,
	"./new_design/standard_message.svg": 6083,
	"./new_design/standard_user.svg": 7455
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;